/** Reads the model-localized status label from a persisted toolCall arguments bag. */
export const readWorkspaceAgentToolCallDescription = (
  argumentsBag: Record<string, unknown> | undefined,
): string | undefined => {
  const description = argumentsBag?.description;

  return typeof description === 'string' && description.length > 0 ? description : undefined;
};
